import React from 'react';
import { convertToWei } from '../utils/walletUtils';
import SummaryRow from './SummaryRow';

const TransferSummary = ({ selectedToken, amount, senderAddress, recipientAddress }) => (
  <div className="mb-3">
    <h6 className="form-label">Transaction Summary</h6>

    <div
      className="card"
    >
      <div className='card-body'>
        <SummaryRow label="Token" value={`${selectedToken?.name || 'N/A'} (${selectedToken?.symbol || ''})`} />
        <SummaryRow label="Amount" value={`${amount} ${selectedToken?.symbol || ''}`} />
        <SummaryRow label="Transfer Type" value="Private Transfer" />
        <SummaryRow
          label="From Railgun Address"
          value={<small className='bg-light w-full p-2 border d-block rounded mb-2'>{senderAddress}</small>}
        />
        <SummaryRow
          label="To Railgun Address"
          value={<small className='bg-light w-full p-2 border d-block rounded mb-2'>{recipientAddress}</small>}
        />
        <SummaryRow
          label="Amount (Wei)"
          value={convertToWei(amount, selectedToken?.decimals)}
        />
      </div>
    </div>
  </div>
);

export default TransferSummary;